import { dayjs } from 'date';
import ExifReader from 'exifreader';
import { logger } from 'monitor';

export interface ExifMetadata {
  timestamp?: string;
}

const EXIF_INCOMING_DATETIME_FORMAT = 'YYYY:MM:DD HH:mm:ss';
const EXIF_DATETIME_FORMAT_REGEX = /^\d{4}:\d{2}:\d{2} \d{2}:\d{2}:\d{2}$/;
const EXIF_DATETIME_WITH_TIMEZONE_REGEX = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:Z|[+-]\d{2}:\d{2})$/;
const POSTGRES_TIMESTAMP_FORMAT = 'YYYY-MM-DDTHH:mm:ss';

export const convertToPostgresUTCTimestamp = (timestamp: string) => {
  if (EXIF_DATETIME_WITH_TIMEZONE_REGEX.test(timestamp)) {
    return timestamp.substring(0, 19);
  }

  if (EXIF_DATETIME_FORMAT_REGEX.test(timestamp)) {
    return dayjs(timestamp, EXIF_INCOMING_DATETIME_FORMAT).format(POSTGRES_TIMESTAMP_FORMAT);
  }

  return undefined;
};

export const extractExifData = async (file: File): Promise<ExifMetadata> => {
  try {
    const arrayBuffer = await file.arrayBuffer();

    const tags = ExifReader.load(arrayBuffer);

    const metadata: ExifMetadata = {};

    if (tags.DateTimeOriginal?.description) {
      metadata.timestamp = convertToPostgresUTCTimestamp(tags.DateTimeOriginal.description);
    } else {
      logger.warn('No DateTimeOriginal found in EXIF data', { tags });

      metadata.timestamp = dayjs().format(POSTGRES_TIMESTAMP_FORMAT);
    }

    return metadata;
  } catch (error) {
    logger.error('Error extracting EXIF data:', error as Error);
    return {
      timestamp: dayjs().format(POSTGRES_TIMESTAMP_FORMAT),
    };
  }
};
